import React from 'react';
import PropTypes from 'prop-types';
import { toInteger } from 'lodash';
import { withRouter } from 'react-router';
import connect from 'react-redux/lib/connect/connect';

import SvgComponent from '../SvgComponent';
import { PATH } from '../../constants/path';
import { STATIC_ROOT } from '../../constants';
import LocalizedNavLink from '../router/LocalizedNavLink';
import { SUB_NAV_CATEGORIES } from '../../services/nav/constants';
import { showSubNav, hideSubNav } from '../../services/nav/actions';
import { clearFilter, filterPartnerOnCategory } from '../../services/filter/actions';
import { formatCategoryNameForUrl } from '../../services/category/utils';
import { buildPathPrefix } from '../../utils/directoryUtils';

class CategoriesSubNavComponent extends React.Component {
    showSubNav = subNav => this.props.showSubNav(subNav);
    hideSubNav = () => this.props.hideSubNav();

    onMouseEnterCategories = () => this.showSubNav(SUB_NAV_CATEGORIES);
    onMouseLeaveCategories = () => this.hideSubNav();

    onClickCategory = id => {
        const { categories, history } = this.props;

        if (toInteger(id) > 0) {
            const category = categories.filter(curr => toInteger(curr.id) === toInteger(id))[0];

            this.props.filterPartnerOnCategory('directory', Number(category.id));
        } else {
            history.push(`${buildPathPrefix(this.props.locale, false)}/${PATH.MOST_POPULAR_PATH}`);
            this.props.clearFilter('directory');
        }
    };

    render() {
        const { subNav, categories } = this.props;
        return (
            <div
                className={`sous-menu-rubriques ${subNav === SUB_NAV_CATEGORIES ? 'open' : ''}`}
                id="sous-menu-rubriques"
                onMouseEnter={this.onMouseEnterCategories}
                onMouseLeave={this.onMouseLeaveCategories}>
                <div className="conteneur flex-container-h">
                    {categories.map((category, i) => {
                        return (
                            <LocalizedNavLink
                                to={`${PATH.CASHBACK_CATEGORY_PATH}${formatCategoryNameForUrl(
                                    category.label
                                )}-${category.id}`}
                                key={i}
                                onClick={() => this.onClickCategory(category.id)}>
                                <SvgComponent
                                    src={`${STATIC_ROOT}/categories/${category.logo}.svg`}
                                />
                                <span>{category.label}</span>
                            </LocalizedNavLink>
                        );
                    })}
                </div>
            </div>
        );
    }
}

CategoriesSubNavComponent.propTypes = {
    categories: PropTypes.array.isRequired,
    subNav: PropTypes.string
};

const mapStateToProps = state => ({
    subNav: state.nav.subNav,
    locale: state.i18n.locale
});

const mapDispatchToProps = {
    showSubNav,
    hideSubNav,
    filterPartnerOnCategory,
    clearFilter
};

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(CategoriesSubNavComponent));



// WEBPACK FOOTER //
// ./src/components/header/CategoriesSubNavComponent.js